module.exports = __webpack_public_path__ + "static/media/cmm.cd5b711c.png";